import { useState } from "react";
import SimpleSelect from "./SimpleSelect";

## Basic Usage (SimpleSelect.Basic)

The simplified API using an `items` array.

export function BasicSelect() {
  const [value, setValue] = useState("");
  return (
    <div style={{ maxWidth: "300px" }}>
      <SimpleSelect.Basic
        items={[
          { type: "item", value: "apple", label: "Apple" },
          { type: "item", value: "banana", label: "Banana", tooltip: "Yellow fruit" },
          { type: "item", value: "orange", label: "Orange" },
          { type: "separator" },
          {
            type: "group",
            label: "Vegetables",
            items: [
              { type: "item", value: "carrot", label: "Carrot" },
              { type: "item", value: "broccoli", label: "Broccoli" },
            ],
          },
        ]}
        value={value}
        onValueChange={setValue}
        placeholder="Select food..."
      />
      <p>Selected: **{value || "none"}**</p>
    </div>
  );
}

<BasicSelect />

---

## With Groups and Separators

export function GroupedSelect() {
  const [value, setValue] = useState("");
  return (
    <div style={{ maxWidth: "300px" }}>
      <SimpleSelect.Root value={value} onValueChange={setValue}>
        <SimpleSelect.Trigger placeholder="Select a food..." />
        <SimpleSelect.Portal>
          <SimpleSelect.Content>
            <SimpleSelect.Viewport>
              <SimpleSelect.Group>
                <SimpleSelect.Label>Fruits</SimpleSelect.Label>
                <SimpleSelect.Item value="apple">Apple</SimpleSelect.Item>
                <SimpleSelect.Item value="banana">Banana</SimpleSelect.Item>
              </SimpleSelect.Group>
              <SimpleSelect.Separator />
              <SimpleSelect.Group>
                <SimpleSelect.Label>Vegetables</SimpleSelect.Label>
                <SimpleSelect.Item value="carrot">Carrot</SimpleSelect.Item>
                <SimpleSelect.Item value="broccoli">Broccoli</SimpleSelect.Item>
              </SimpleSelect.Group>
            </SimpleSelect.Viewport>
          </SimpleSelect.Content>
        </SimpleSelect.Portal>
      </SimpleSelect.Root>
    </div>
  );
}

<GroupedSelect />

---

## Disabled

<div style={{ maxWidth: "300px" }}>
  <SimpleSelect.Root disabled defaultValue="disabled">
    <SimpleSelect.Trigger placeholder="This is disabled..." />
    <SimpleSelect.Portal>
      <SimpleSelect.Content>
        <SimpleSelect.Viewport>
          <SimpleSelect.Item value="option1">Option 1</SimpleSelect.Item>
          <SimpleSelect.Item value="disabled">Disabled option</SimpleSelect.Item>
        </SimpleSelect.Viewport>
      </SimpleSelect.Content>
    </SimpleSelect.Portal>
  </SimpleSelect.Root>
</div>

---

## With Tooltips

export function TooltipSelect() {
  const [value, setValue] = useState("");
  return (
    <div style={{ maxWidth: "300px" }}>
      <SimpleSelect.Root value={value} onValueChange={setValue}>
        <SimpleSelect.Trigger placeholder="Select technology..." />
        <SimpleSelect.Portal>
          <SimpleSelect.Content>
            <SimpleSelect.Viewport>
              <SimpleSelect.Item value="react" tooltip="JavaScript library for UIs">
                React
              </SimpleSelect.Item>
              <SimpleSelect.Item value="typescript" tooltip="JavaScript with types">
                TypeScript
              </SimpleSelect.Item>
              <SimpleSelect.Item value="next" tooltip="React framework">
                Next.js
              </SimpleSelect.Item>
            </SimpleSelect.Viewport>
          </SimpleSelect.Content>
        </SimpleSelect.Portal>
      </SimpleSelect.Root>
    </div>
  );
}

<TooltipSelect />
